import { Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Constants from "../../utils/constants";
import { langStringConvertor } from "../../utils/utils";
import StationEta from "../StationEta";
import "./styles.scss";

const { LANGUAGES } = Constants;
const { feeText } = LANGUAGES;

const EtaCard = (props) => {
  const { stops, lang, message, etaDisplayMethod, themeColour, nearestStop, showLicensePlate, vehicleLocations } = props;

  const [language, setLanguage] = useState(props.lang);

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  return (
    <Paper className={`eta-card expand`} elevation={4}>
      <div className="content">
        {stops.map((station, index) => {
          const isNearestStop = !!nearestStop && station.stop_id === nearestStop.stop_id;
          return (
            <StationEta
              stationName={station[`name_${langStringConvertor(language)}`]}
              time={station.eta ? station.eta : null}
              lang={language}
              key={index}
              index={index}
              message={message}
              etaDisplayMethod={etaDisplayMethod}
              themeColour={themeColour}
              isNearestStop={isNearestStop}
              showLicensePlate={showLicensePlate}
              vehicleLocations={vehicleLocations}
            />
          );
        })}
      </div>
    </Paper>
  );
};

export default EtaCard;
